module.exports = __webpack_public_path__ + "img/log-out.67085406.svg";